import React, { useState, useEffect, useRef } from "react";
import Header from "../../common/Header";
import SideBar from "../../common/SideBar";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { FormField, FileUploadField } from "../../common/FormFields";
import PermissionsGate from "../../../utils/permissionGate";
import HtmlInputEditor from "../../common/HtmlInputEditor";
import CSSEditor from "../../common/CSSEditor";
import SectionColorOverrideComponent from "../../website/SectionColorOverrideComponent";
import {updatePartner, getPartner, getProgrammeOptions} from "../../../services/WebsiteListServer";
import {
  getStaticPagesHeaderList,
  getStaticPagesPopupList
} from "../../../services/StaticPgesServer";
import { getBlockVariantTypeDropDown, getBrandTemplateStatus, getHeaderDropDownListStatic, getPopUpListStatic } from "../../../services/BrandTemplateServices";
import { useParams } from 'react-router-dom';

const PartnerDetails = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [header, setHeader] = useState([]);
  const [popup, setPopup] = useState([]);
  const [editorState, setEditorState] = useState(null);
  const [learnignBlockArr, setLearnignBlockArr] = useState([]);
  const [testimonialsBlockArr, setTestimonialsBlockArr] = useState([]);
  const [partnerData, setPartnerData] = useState({});
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [subsidiaryOptions, setSubsidiaryOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [programmeOptions, setProgrammeOptions] = useState([]);
  const [allProgrammeOptions, setAllProgrammeOptions] = useState([]);
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [selectedSubsidiaries, setSelectedSubsidiaries] = useState([]);
  const [selectedProductTypes, setSelectedProductTypes] = useState([]);
  const [loadingProgrammeOptions, setLoadingProgrammeOptions] = useState(false);
  useEffect(() => {
    setLoading(true);
    
    const fetchDropdownList = () => {
      getStaticPagesHeaderList()
      .then(res => setHeader(res?.data?.Data))
      
      getStaticPagesPopupList()
      .then(res => setPopup(res?.data?.Data))
      
      setLoading(false);
    }
    
    fetchDropdownList();
  }, [])
  useEffect(() => {
    setLoadingProgrammeOptions(true);
    const data = {
      selectedSchools: selectedSchools,
      selectedSubsidiaries: selectedSubsidiaries,
      selectedProductTypes: selectedProductTypes,
    };
    // if any array is blank, then set programme options to null and return
    if (selectedSchools?.length === 0 || selectedSubsidiaries?.length === 0 || selectedProductTypes?.length === 0) {
      setProgrammeOptions([]);
      setLoadingProgrammeOptions(false);
      return;
    }
    try {
      const res = getProgrammeOptions(data).then((res) => {
        // console.log("getProgrammeOptions", res);
        if(res?.data?.programmeOptions){
          setProgrammeOptions(res?.data?.programmeOptions);
        }
        if(res?.data?.allProgrammeOptions){
          setAllProgrammeOptions(res?.data?.allProgrammeOptions);
        }
        
        setLoadingProgrammeOptions(false);
      })
    } catch (error) {
      console.error('Error fetching programme options', error);
      console.error('Error fetching programme options', error);
      setLoadingProgrammeOptions(false);
    }
  }, [selectedSubsidiaries, selectedSchools, selectedProductTypes]);
  
  useEffect(() => {
    
    try{
      if(id != 0){
        setLoading(true);  
        getPartner(id).then((res) => {
          // console.log("res", res);
          setPartnerData(res?.data?.data);
          setEditorState(res?.data?.data?.BodyContent);
          setCampaignOptions(res?.data?.campaignOptions);
          setSubsidiaryOptions(res?.data?.subsidiaryOptions);
          setProductOptions(res?.data?.itemTypes);
          setSchoolOptions(res?.data?.schoolOptions);
          setSelectedSchools(res?.data?.data?.sellable_schools);
          setSelectedSubsidiaries(res?.data?.data?.subsidiaries);
          setSelectedProductTypes(res?.data?.data?.product_types);
          // console.log("PRoductTypes ", res?.data?.product_types, "schools ", res?.data?.sellable_schools, "subsidiaries ", res?.data?.subsidiaries);
          setLoading(false);
        });
      }
    }catch(err){
      setLoading(false);
    }
  }, [id]);
  useEffect(() => {
    
    try{ 
      setLoading(true);    
      getPartner(id || 0).then((res) => {
        // console.log("res", res);
        if(id && id > 0){
          setPartnerData(res?.data?.data);
        }
        setCampaignOptions(res?.data?.campaignOptions);
        setSubsidiaryOptions(res?.data?.subsidiaryOptions);
        setProductOptions(res?.data?.itemTypes);
        setSchoolOptions(res?.data?.schoolOptions);
        setSelectedSchools(res?.data?.data?.sellable_schools);
        setSelectedSubsidiaries(res?.data?.data?.subsidiaries);
        setSelectedProductTypes(res?.data?.data?.product_types);
        // console.log("1PRoductTypes ", res?.data?.product_types, "schools ", res?.data?.sellable_schools, "subsidiaries ", res?.data?.subsidiaries);
        setLoading(false);
      });
      
    }catch(err){
      setLoading(false);
    }
  }, []);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statusRes, headerRes, BlockVariantTypeRes, PopUpRes] = await Promise.all([
          getBrandTemplateStatus(),
          getHeaderDropDownListStatic(),
          getBlockVariantTypeDropDown(),
          getPopUpListStatic()
        ]);
        const statusFilters = statusRes.data.statusFilters || [];
        const popUpFilters = PopUpRes.data.Data || [];
        const headerFilters = headerRes.data.Data || [];
        const learnignBlockFilters = BlockVariantTypeRes.data.learnignBlock || [];
        const testimonialsBlockFilters = BlockVariantTypeRes.data.testimonialsBlock || [];
        setLearnignBlockArr(learnignBlockFilters);
        setTestimonialsBlockArr(testimonialsBlockFilters);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };
    
    fetchData();
  }, []);
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      // functional vars
      id: id,
      name: partnerData?.name ? partnerData?.name : "",
      website: partnerData?.website ? partnerData?.website : "",
      referrer_link:  partnerData?.slug ? `https://aie.ac/partners/${partnerData?.slug}` : partnerData?.referrer_link ? partnerData?.referrer_link : "",
      logo: partnerData?.logo ? partnerData?.logo : "",
      lead_source: partnerData?.lead_source ? partnerData?.lead_source : "",
      campaign: partnerData?.campaign ? partnerData?.campaign : "",
      subsidiaries: partnerData?.subsidiaries ? partnerData?.subsidiaries : "",
      product_types: partnerData?.product_types ? partnerData?.product_types : "",
      
      // Static page vars
      slug: partnerData?.slug ?? "",
      pageTitle: partnerData?.PageTitle ?? "",
      BodyContent: partnerData?.BodyContent ?? null,
      SliderID: partnerData?.SliderID ?? "",
      PopupID: partnerData?.PopupID ?? "",
      FormDestinationEmail: partnerData?.FormDestinationEmail ?? "",
      UseBottomForm: partnerData?.UseBottomForm ?? 'No',
      conversion_code: partnerData?.conversion_code ?? "",
      metaTitle: partnerData?.MetaTitle ?? "",
      metaDescription: partnerData?.MetaDescription ?? "",
      metaKeywords: partnerData?.MetaKeywords ?? "",
      customCss: partnerData?.customCss ?? "",
      addCustomCss: partnerData?.addCustomCss ?? 0,
      ShowTitleInBody: partnerData?.ShowTitleInBody ?? 0,
      IsPublished: partnerData?.IsPublished ?? "",
      type: partnerData?.type ?? 0,
      school_category_show_block: partnerData?.school_category_show_block ?? 0,
      school_category_search_bar: partnerData?.school_category_search_bar ?? 0,
      school_category_text: partnerData?.school_category_text ?? "",
      secondary_category_show_block: partnerData?.secondary_category_show_block ?? 0,
      secondary_category_text: partnerData?.secondary_category_text ?? "",
      upcoming_opendays_show_block: partnerData?.upcoming_opendays_show_block ?? 0,
      upcoming_opendays_text: partnerData?.upcoming_opendays_text ?? "",
      learning_method_show_block: partnerData?.learning_method_show_block ?? 0,
      learning_method_block_variant: partnerData?.learning_method_block_variant ?? "",
      learning_method_block_text: partnerData?.learning_method_block_text ?? "",
      testimonials_block_show: partnerData?.testimonials_block_show ?? 0,
      testimonials_block_variant: partnerData?.testimonials_block_variant ?? "",
      testimonials_block_text: partnerData?.testimonials_block_text ?? "",
      news_block_show: partnerData?.news_block_show ?? 0,
      news_block_text: partnerData?.news_block_text ?? "",
      school_override_color: partnerData?.school_override_color ?? 0,
      school_accentColor: partnerData?.school_accentColor ?? "#007BFF",
      school_textColorOne: partnerData?.school_textColorOne ?? "#007BFF",
      school_textColorTwo: partnerData?.school_textColorTwo ?? "#007BFF",
      school_backgroundColor: partnerData?.school_backgroundColor ?? "#007BFF",
      openday_override_color: partnerData?.openday_override_color ?? 0,
      openday_accentColor: partnerData?.openday_accentColor ?? "#007BFF",
      openday_textColorOne: partnerData?.openday_textColorOne ?? "#007BFF",
      openday_textColorTwo: partnerData?.openday_textColorTwo ?? "#007BFF",
      openday_backgroundColor: partnerData?.openday_backgroundColor ?? "#007BFF",
      learning_method_override_color: partnerData?.learning_method_override_color ?? 0,
      learning_method_accentColor: partnerData?.learning_method_accentColor ?? "#007BFF",
      learning_method_textColorOne: partnerData?.learning_method_textColorOne ?? "#007BFF",
      learning_method_textColorTwo: partnerData?.learning_method_textColorTwo ?? "#007BFF",
      learning_method_backgroundColor: partnerData?.learning_method_backgroundColor ?? "#007BFF",
      testimonials_override_color: partnerData?.testimonials_override_color ?? 0,
      testimonials_accentColor: partnerData?.testimonials_accentColor ?? "#007BFF",
      testimonials_textColorOne: partnerData?.testimonials_textColorOne ?? "#007BFF",
      testimonials_textColorTwo: partnerData?.testimonials_textColorTwo ?? "#007BFF",
      testimonials_backgroundColor: partnerData?.testimonials_backgroundColor ?? "#007BFF",
      news_override_color: partnerData?.news_override_color ?? 0,
      news_accentColor: partnerData?.news_accentColor ?? "#007BFF",
      news_textColorOne: partnerData?.news_textColorOne ?? "#007BFF",
      news_textColorTwo: partnerData?.news_textColorTwo ?? "#007BFF",
      news_backgroundColor: partnerData?.news_backgroundColor ?? "#007BFF",
      toggle_brand_template: partnerData?.toggle_brand_template ?? 0,
      groupByCourseLandingPages: partnerData?.groupByCourseLandingPages ?? 0,
      // legacy style vars
      
      primary_color: partnerData?.primary_color ? partnerData.primary_color : "#ffffff",
      secondary_color: partnerData?.secondary_color ? partnerData.secondary_color : "#ffffff",
      tertiary_color: partnerData?.tertiary_color ? partnerData.tertiary_color : "#ffffff",
      form_background_color: partnerData?.form_background_color ? partnerData.form_background_color : "#ffffff",
      form_text_color: partnerData?.form_text_color ? partnerData.form_text_color : "#000000",
      form_button_color: partnerData?.form_button_color ? partnerData.form_button_color : "#000000",
      form_button_text_color: partnerData?.form_button_text_color ? partnerData.form_button_text_color : "#000000",
      form_heading_text_color: partnerData?.form_heading_text_color ? partnerData.form_heading_text_color : "#000000",
      form_disabled_field_color: partnerData?.form_disabled_field_color ? partnerData.form_disabled_field_color : "#000000",
      form_input_text_color: partnerData?.form_input_text_color ? partnerData.form_input_text_color : "#000000",
      form_input_color: partnerData?.form_input_color ? partnerData.form_input_color : "#000000",
      requestParentDetails: partnerData?.requestParentDetails || 0 ,
      status: partnerData?.status || 0,
      sellable_schools: partnerData?.sellable_schools || [],
      requestMatriculationYear: partnerData?.requestMatriculationYear || 0 ,
      available_programmes: partnerData?.available_programmes ? partnerData?.available_programmes.split(',') : [] ,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      subsidiaries: Yup.array().required("Subsidiaries is required"),
      product_types: Yup.array().required("Product types is required"),
      lead_source: Yup.number().required("Lead source is required"),
      available_programmes: Yup.array().required("Available programmes is required"),
      sellable_schools: Yup.array().required("Sellable schools is required"),
      customCss: Yup.string().when("addCustomCss", {
        is: (value) => value == 1,
        then: Yup.string().required("Custom CSS is required"),
        otherwise: Yup.string().nullable()
      }),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const formData = new FormData();
      let trimmedValues = Object.fromEntries(
        Object.entries(values).map(([key, value]) => [
          key,
          typeof value === "string" ? value.trim().replace(/ +/g, " ") : value,
        ])
      );
      trimmedValues.subsidiaries = trimmedValues?.subsidiaries?.length >0 ? trimmedValues.subsidiaries.join(",") : "";
      trimmedValues.product_types = trimmedValues?.product_types?.length > 0 ? trimmedValues.product_types.join(",") : "";
      trimmedValues.sellable_schools = trimmedValues?.sellable_schools?.length>0 ? trimmedValues.sellable_schools.join(",") : "";
      trimmedValues.available_programmes = trimmedValues?.available_programmes?.length > 0 ? trimmedValues.available_programmes.join(",") : "";
      Object.keys(trimmedValues).forEach((key) => {
        if (Array.isArray(trimmedValues[key])) {
          trimmedValues[key].forEach((val, idx) => {
            formData.append(`${key}[${idx}]`, val);
          });
        } else {
          formData.append(key, trimmedValues[key]);
        }
      });
      updatePartner(formData, id)
      .then((response) => {
        Swal.fire("Added!", "Your record has been Saved.", "success").then(() => {
          setLoading(false);
          if(id && id > 0){
            window.location.reload();
          }else{
            history.push(`/website_management/partnerDetails/${response.data.id}`);
          }
        });
      })
      .catch((error) => {
        console.error("Error updating Partner:", error);
        Swal.fire("Error!", "Failed to update Partner", "error");
        setLoading(false);
      });
    },
  });
  
  return (
    <>
    <Header />
    <div className="content-wrapper d-flex flex-wrap">
    <SideBar />
    <div className="sidebar-right">
    <div className="sub-menu-content-block">
    <div className="sub-menu-right-block">
    <div className="wrap-box-right">
    <div className="my-tickets-heading-blk flex-direction mb-2">
    <div className="d-flex align-items-center">
    <div className="name-w-head d-flex align-items-center">
    <h4 className="text-left-align landing-heading heading_color_dynamic">
    {loading ? <>Partner: Loading...<i className="fas fa-cog fa-spin"></i></> : partnerData?.name ? <>Partner:<span> {partnerData?.name}</span></> : (<>Create <span>Partner</span></>)} {(partnerData?.slug || partnerData?.referrer_link) ? <>-  <a href = {partnerData?.slug ? `https://aie.ac/partners/${partnerData?.slug}` : partnerData?.referrer_link ? partnerData?.referrer_link : ""} target="_blank">{partnerData?.slug ? `https://aie.ac/partners/${partnerData?.slug}` : partnerData?.referrer_link ? partnerData?.referrer_link : ""}</a></> : ""}
    </h4>
    </div>
    <div className="text-md-right action2-blk">
    <div className="ticket-view-btn d-flex align-items-center">
    <div className="add-new-ticket-bx">
    <button
    onClick={() => history.goBack()}
    title="Back"
    className="btn btn-white-bordered"
    >
    <i className="fal fa-angle-left"></i>Back
    </button>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    <div className="tabs-wrap">
    <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
    <li className="nav-item">
    <div className="nav-link active" id="pills-tab1" role="tab" aria-selected="true">
    <i className="fal fa-info-circle"></i>Details
    </div>
    </li>
    </ul>
    
    <div className="tab-content" id="pills-tabContent">
    <div className="tab-pane fade active show" role="tabpanel">
    <div className="card card-body-inr">
    <form onSubmit={formik.handleSubmit}>
    <div className="my-tickets-info-list Tickets-main-wrap">
    <div className="edit-icon new-card-header">
    <div className="card-header">
    <strong>Partner Details</strong> {loading ? <><i className="fas fa-cog fa-spin"></i></> : ""} <span style={{color: '#87A3B3', fontStyle: 'italic'}}></span>
    </div>
    </div>
    
    <div className="row">
    <FormField col_lg={3} field={{ name: "name", label: "Name" }} formik={formik}/>
    <FormField col_lg={3} field={{ name: "slug", label: "Link Name" }} formik={formik}/>
    <div className="col-md-6 col-lg-3">
    <label htmlFor="LeadSource">Status *</label>
    <div className="form-icon-group mb-3">
    <Select
    className={`form-control custom-select-box ${formik.touched.status && formik.errors.status && "is-invalid"
    }`}
    name="status"
    value={[{label:"Active", value: 0}, {label:"Disabled", value: 1}].find((item) => item.value === formik.values?.status)}
    onChange={(option) => formik.setFieldValue("status", option.value)}
    onBlur={formik.handleBlur}
    options={[{label:"Active", value: 0}, {label:"Disabled", value: 1}]}
    maxMenuHeight={175}
    placeholder="Select Status"
    />
    </div>
    </div>
    {/* <FormField col_lg={2} field={{ name: "website", label: "Website" }} formik={formik} required={false}/> */}
    {/*Add dropdown field for lead_source, options are campaignOptions */}
    <div className="col-md-6 col-lg-3">
    <label htmlFor="LeadSource">Lead Source *</label>
    <div className="form-icon-group mb-3">
    <Select
    className={`form-control custom-select-box ${formik.touched.lead_source && formik.errors.lead_source && "is-invalid"
    }`}
    name="lead_source"
    value={campaignOptions.find((item) => item.value === formik.values?.lead_source)}
    onChange={(option) => formik.setFieldValue("lead_source", option.value)}
    onBlur={formik.handleBlur}
    options={campaignOptions}
    maxMenuHeight={175}
    placeholder="Select Lead Source"
    />
    </div>
    </div>
    {/* <FormField field={{ name: "campaign", label: "Campaign" }} formik={formik} required={false}/> */}
    <div className="col-md-6 col-lg-3">
    <label htmlFor="subsidiaries">Assigned Subsidiaries * <i className="fal fa-info-circle"></i></label>
    <div className="form-icon-group mb-3">
    <Select
    className={`form-control custom-select-box ${formik.touched.subsidiaries && formik.errors.subsidiaries && "is-invalid"}`}
    name="subsidiaries"
    value={subsidiaryOptions.filter((val) => formik.values?.subsidiaries?.includes(val.value))}
    onChange={(value) => { 
      formik.setFieldValue( "subsidiaries", value ? value.map((v) => v.value) : []); 
      setSelectedSubsidiaries(value ? value.map((v) => v.value) : []);
    }}
    isClearable
    onBlur={formik.handleBlur}
    options={subsidiaryOptions}
    maxMenuHeight={175}
    placeholder="Select"
    isMulti
    />
    </div>
    </div>    
    </div>
    </div>
    
    <hr />
    <div className="my-tickets-info-list Tickets-main-wrap">
    <div className="edit-icon new-card-header">
    <div className="card-header">
    <strong>Partner Settings</strong>
    </div>
    </div>
    <div className="row">
    <div className="col-md-6 col-lg-3">
    <label htmlFor="product_types">Product Types * <i className="fal fa-info-circle"></i></label>
    <div className="form-icon-group mb-4">
    <Select
    className={`form-control custom-select-box ${formik.touched.product_types && formik.errors.product_types && "is-invalid"}`}
    name="product_types"
    value={productOptions.filter((val) => formik.values?.product_types?.includes(val.value))}
    onChange={(value) => { 
      formik.setFieldValue( "product_types", value ? value.map((v) => v.value) : []); 
      setSelectedProductTypes(value ? value.map((v) => v.value) : []);
    }}
    isClearable
    onBlur={formik.handleBlur}
    options={productOptions}
    maxMenuHeight={175}
    placeholder="Select"
    isMulti
    />
    </div>
    </div>
    <div className="col-md-6 col-lg-3">
    <label htmlFor="sellable_schools">Allowed Schools * <i className="fal fa-info-circle"></i></label>
    <div className="form-icon-group mb-4">
    <Select
    className={`form-control custom-select-box ${formik.touched.sellable_schools && formik.errors.sellable_schools && "is-invalid"}`}
    name="sellable_schools"
    value={schoolOptions.filter((val) => formik.values?.sellable_schools?.includes(val.value))}
    onChange={(value) => { 
      formik.setFieldValue( "sellable_schools", value ? value.map((v) => v.value) : []);
      setSelectedSchools(value ? value.map((v) => v.value) : []); 
    }}
    isClearable
    onBlur={formik.handleBlur}
    options={schoolOptions}
    maxMenuHeight={175}
    placeholder="Select"
    isMulti
    />
    </div>
    </div>
    <div title="Programmes the partner is not allowed to sell" className="col-md-6 col-lg-3">
    <label htmlFor="available_programmes">Available Programmes {loadingProgrammeOptions ? (<><i className="fas fa-cog fa-spin"></i></>) : (<> <i className="fal fa-info-circle"></i></>)}</label>
    <div className="form-icon-group mb-4">
    <Select
    className={`form-control custom-select-box ${formik.touched.available_programmes && formik.errors.available_programmes && "is-invalid"}`}
    name="available_programmes"
    value={programmeOptions.filter((val) => 
      formik.values?.available_programmes?.includes(val.value)
    )}
    onChange={(selectedOptions) => { 
      formik.setFieldValue(
        "available_programmes", 
        selectedOptions ? selectedOptions.map((v) => v.value) : []
      );
    }}
    isClearable
    onBlur={formik.handleBlur}
    options={programmeOptions}
    maxMenuHeight={175}
    placeholder="Select"
    isMulti
    />
    </div>
    </div>
    <div className="col-md-6 col-lg-3">
    <div
    className="d-flex my-20"
    title="Add form inputs for parent name, mobile, email"
    style={{ paddingLeft: '15px'}}
    >
    <label className="mb-0">
    Request Parent Details
    <i className="fal fa-info-circle grade-icon ml-2"></i>
    </label>
    <div className="toggle-switch ml-2">
    <label className="switch">
    <input
    type="checkbox"
    checked={formik?.values?.requestParentDetails == 1}
    onChange={(e) => {
      formik.setFieldValue(
        'requestParentDetails',
        e.target.checked ? 1 : 0
      );
    }}
    />
    <span className="slider slider-round"></span>
    </label>
    </div>
    </div>    
    <div
    className="d-flex my-20"
    title="Add form Matriculation Year"
    style={{ paddingLeft: '15px'}}
    >
    <label className="mb-0">
    Request Matriculation Year
    <i className="fal fa-info-circle grade-icon ml-2"></i>
    </label>
    <div className="toggle-switch ml-2">
    <label className="switch">
    <input
    type="checkbox"
    checked={formik?.values?.requestMatriculationYear == 1}
    onChange={(e) => {
      formik.setFieldValue(
        'requestMatriculationYear',
        e.target.checked ? 1 : 0
      );
    }}
    />
    <span className="slider slider-round"></span>
    </label>
    </div>
    </div> 
    </div>
    </div>
    </div>
    <hr />
    
    <div className="my-tickets-info-list Tickets-main-wrap">
    <div className="edit-icon new-card-header">
    <div className="card-header">
    <strong>Partner Form Settings</strong>
    </div>
    </div>
    <div className="row">
    <div className="col-md-12">
    <div className="row mt-2">
    {[
      { inputTitle:"Color of the form heading" ,label: "Form Heading Text Color", color: true, name: "form_heading_text_color", type: "color"},
      { inputTitle:"Text color of labels on Form" ,label: "Form Text Color", color: true, name: "form_text_color", type: "color" },
      { inputTitle:"Color of inputs on Form" ,label: "Form Input Color", color: true, name: "form_input_color", type: "color" },
      { inputTitle:"Text color of inputs on Form" ,label: "Form Input Text Color", color: true, name: "form_input_text_color", type: "color" },            
      // { inputTitle:"Color of the disabled Programmes field when shool has not been selected", label: "Form Disabled Field Color", color: true, name: "form_disabled_field_color", type: "color"},
      { inputTitle:"Background color of Form, 80% transparency will be applied", label: "Form Background Color", color: true, name: "form_background_color", type: "color" },            
      { inputTitle:"Color of submit button on Form" ,label: "Form Button Color", color: true, name: "form_button_color", type: "color"},
      { inputTitle:"Color of text on submit button" ,label: "Form Button Text Color", color: true, name: "form_button_text_color", type: "color"},
      // { inputTitle:"Used in the rotating background colors" ,label: "Rotary Color 1", color: true, name: "primary_color", type: "color" },
      // { inputTitle:"Used in the rotating background colors" ,label: "Rotary Color 2", color: true, name: "secondary_color", type: "color" },
      // { inputTitle:"Used in the rotating background colors" ,label: "Rotary Color 3", color: true, name: "tertiary_color", type: "color" }
    ].map((field, index) => (
      <FormField col_lg={3} key={index} field={field} formik={formik} />
    ))}
    <FileUploadField
    name={"logo"}
    label={"Logo"}
    formik={formik}
    accept=".png,.jpg,.jpeg"
    col_md={6}
    col_lg={3}
    required={false}
    />
    </div>                                                           
    </div>
    </div>
    </div>
    <hr/>
    <div className="my-tickets-info-list Tickets-main-wrap">
    <div className="edit-icon new-card-header">
    <div className="card-header">
    <strong>Page Information</strong>
    </div>
    </div>
    <div className="row">
    <div className="col-md-6 col-lg-3">
    <div className="form-group-blk mb-3" title="Page Title">
    <label>Page Title *</label>
    <input
    type="text"
    className={
      "form-control" +
      (formik.errors.pageTitle && formik.touched.pageTitle
        ? " is-invalid"
        : "")
      }
      placeholder="Enter Page Title"
      name="pageTitle"
      id="pageTitle"
      value={formik.values?.pageTitle}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      />
      </div>
      </div>
      
      <div className="col-md-12">
      <div className="form-group-blk mb-3">
      <label title="Page Content">Page Content</label>
      {
        
        <>
        
        <HtmlInputEditor
        initialValue={partnerData?.BodyContent}
        editorState={editorState}
        setEditorState={(editorState) => {
          formik.setFieldValue('BodyContent', editorState);
          setEditorState(editorState);
        }}
        hideSign
        isCKEditor
        />
        
        </>
      }
      </div>      
      </div>
      </div>
      <hr/>
      
      <div className="my-tickets-info-list Tickets-main-wrap">
      <div className="edit-icon new-card-header">
      <div className="card-header">
      <strong>Page Settings</strong>
      </div>
      </div>
      <div className="row">
      <div className="col-md-6 col-lg-3">
      <div className="form-group-blk mb-3" title="Header">
      <label>Header <i className="fal fa-info-circle"></i></label>
      <Select
      className={
        "form-control custom-select-box" +
        (formik.errors.SliderID && formik.touched.SliderID
          ? " is-invalid"
          : "")
        }
        name="SliderID"
        value={header.find(val => val.value === formik.values?.SliderID)}
        onChange={(option) => {
          formik.setFieldValue("SliderID", option ? option.value : "");
        }}
        onBlur={formik.handleBlur}
        options={header}
        maxMenuHeight={175}
        placeholder={
          formik.values?.SliderID || "AIE Default"
        }
        isClearable
        />
        </div>
        </div>
        <div className="col-md-6 col-lg-3">
        <div className="form-group-blk mb-3" title="Popup">
        <label>Popup <i className="fal fa-info-circle"></i></label>
        <Select
        className={
          "form-control custom-select-box" +
          (formik.errors.PopupID && formik.touched.PopupID
            ? " is-invalid"
            : "")
          }
          name="PopupID"
          value={popup.find(val => val.value === formik.values?.PopupID)}
          onChange={(option) => {
            formik.setFieldValue("PopupID", option ? option.value : "");
          }}
          onBlur={formik.handleBlur}
          options={popup}
          maxMenuHeight={175}
          placeholder={
            formik.values?.PopupID || "Default"
          }
          isClearable
          />
          </div>
          </div>
          <div className="col-md-6 col-lg-3 d-flex" style={{ marginTop: 35 }} title="Show Bottom Form">
          <label className="mb-0">
          Show Bottom Form <i className="fal fa-info-circle"></i>
          </label>
          <div className="toggle-switch ml-2">
          <label className="switch">
          <input
          type="checkbox"
          name="useBottomForm"
          checked={formik.values?.UseBottomForm === "Yes"}
          onChange={(e) => {
            formik.setFieldValue(
              "UseBottomForm",
              e.target.checked ? "Yes" : "No"
            )
          }}
          />
          <span className="slider slider-round"></span>
          </label>
          </div>
          </div>                             
          <div className="new-card-header col-md-12">
          <div className="row mb-4">
          <div className="col-md-12">
          <div className="edit-icon new-card-header">
          <h4 className="card-header">
          <i className="fal fa-cog" style={{ color: "var(--topbar-color)" }}></i> Section Settings                                        
          </h4>
          </div>
          </div>          
          <div
          className="d-flex col-md-12" 
          title="Overwrite Section Content and settings of page components, this overwrites the settings on the brand template and is only applicable to this page."
          >
          <label className="mb-0">
          Override Brand Template Section Settings <i className="fal fa-info-circle grade-icon"></i>
          </label>
          <div className="toggle-switch ml-2">
          <label className="switch">
          <input
          type="checkbox"
          checked={formik.values?.toggle_brand_template == 1 }
          onChange={(e) => {
            formik.setFieldValue(
              "toggle_brand_template", 
              e.target.checked ? 1 : 0
            );
          }}
          />
          <span className="slider slider-round"></span>
          </label>
          </div>
          </div>
          
          </div>
          </div>
          {formik.values?.toggle_brand_template == 1 ? (<>
            <div className="col-12">
            <div className="row">
            <div className="col-md-12">
            <div className="edit-icon new-card-header">
            <h4 className="card-header">Schools Category Section </h4>
            </div>
            </div>
            
            
            <div className={`col-md-6 col-lg-3`}>
            <label htmlFor={"Section Settings"}>
            Section Settings
            </label>
            <div className="form-icon-group mt-3">
            <div className="custom-control custom-checkbox text-left mb-3 mr-3" title="Show Block">
            <input
            type="checkbox"
            className="custom-control-input"
            id="school_category_show_block"
            name="school_category_show_block"
            checked={formik.values?.school_category_show_block == 1}
            onChange={(e) => {
              formik.setFieldValue(
                "school_category_show_block",
                e.target.checked ? 1 : 0
              );
            }}
            />
            <label
            className="custom-control-label"
            htmlFor="school_category_show_block"
            >
            Show Section
            </label>
            </div>
            <div className="custom-control custom-checkbox text-left" title="Show Course Search Bar">
            <input
            type="checkbox"
            className="custom-control-input"
            id="school_category_search_bar"
            name="school_category_search_bar"
            checked={formik.values?.school_category_search_bar == 1}
            onChange={(e) => {
              formik.setFieldValue(
                "school_category_search_bar",
                e.target.checked ? 1 : 0
              );
            }}
            />
            <label
            className="custom-control-label"
            htmlFor="school_category_search_bar"
            >
            Show Course Search Bar
            </label>
            </div>
            </div>
            </div>
            <div className="col-md-6 col-lg-9">
            <label htmlFor="school_category_text" title="Site Name">Section Title Text</label>
            <div className="form-icon-group" title="site_Name">
            <input
            type="text"
            className={`form-control ${formik.touched.school_category_text && formik.errors.school_category_text && "is-invalid"
            }`}
            name="school_category_text"
            id="school_category_text"
            title="Section Title Text"
            placeholder="Section Title Text"
            value={formik.values?.school_category_text}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            </div>
            </div>
            </div>
            <div
            className="d-flex my-20"
            title="Group Content by Course Landing Pages and not by schools"
            >
            <label className="mb-0">
            Group Content by Course Landing Pages
            <i className="fal fa-info-circle grade-icon ml-2"></i>
            {/* <a href={formik.values?.external_link} target="_blank"><i className="fal fa-external-link color-sidebar ml-2"></i></a> */}
            </label>
            <div className="toggle-switch ml-2">
            <label className="switch">
            <input
            type="checkbox"
            checked={formik.values?.groupByCourseLandingPages == 1}
            onChange={(e) => {
              formik.setFieldValue(
                'groupByCourseLandingPages',
                e.target.checked ? 1 : 0
              );
            }}
            />
            <span className="slider slider-round"></span>
            </label>
            </div>
            </div>
            <SectionColorOverrideComponent 
            prefix="school_" 
            formik={formik} 
            fields={["accentColor", "textColorOne", "textColorTwo", "backgroundColor"]} />
            <hr />
            </div>
            
            <div className="col-12">
            <div className="row pt-1">
            <div className="col-md-12">
            <div className="edit-icon new-card-header">
            <h4 className="card-header">Secondary Category Section</h4>
            </div>
            </div>
            
            <div className={`col-md-6 col-lg-3`}>
            <label htmlFor={"Section Settings"}>
            Section Settings
            </label>
            <div className="form-icon-group mt-3">
            <div className="custom-control custom-checkbox text-left mb-3 mr-3" title="Show Block">
            <input
            type="checkbox"
            className="custom-control-input"
            id="secondary_category_show_block"
            name="secondary_category_show_block"
            checked={formik.values?.secondary_category_show_block == 1}
            onChange={(e) => {
              formik.setFieldValue(
                "secondary_category_show_block",
                e.target.checked ? 1 : 0
              );
            }}
            />
            <label
            className="custom-control-label"
            htmlFor="secondary_category_show_block"
            >
            Show Section
            </label>
            </div>
            </div>
            </div>
            <div className="col-md-6 col-lg-9">
            <label htmlFor="secondary_category_text" title="Site Name">Section Title Text</label>
            <div className="form-icon-group" title="site_Name">
            <input
            type="text"
            className={`form-control ${formik.touched.secondary_category_text && formik.errors.secondary_category_text && "is-invalid"
            }`}
            name="secondary_category_text"
            id="secondary_category_text"
            title="Section Title Text"
            placeholder="Section Title Text"
            value={formik.values?.secondary_category_text}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            </div>
            </div>
            </div>
            <hr />
            </div>
            
            
            <div className="col-12">
            <div className="row pt-1">
            <div className="col-md-12">
            <div className="edit-icon new-card-header">
            <h4 className="card-header">Upcoming Open Days Block</h4>
            </div>
            </div>
            
            <div className={`col-md-6 col-lg-3`}>
            <label htmlFor={"Section Settings"}>
            Section Settings
            </label>
            <div className="form-icon-group mb-4 mt-3">
            <div className="custom-control custom-checkbox text-left mr-3" title="Show Block">
            <input
            type="checkbox"
            className="custom-control-input"
            id="upcoming_opendays_show_block"
            name="upcoming_opendays_show_block"
            checked={formik.values?.upcoming_opendays_show_block == 1}
            onChange={(e) => {
              formik.setFieldValue(
                "upcoming_opendays_show_block",
                e.target.checked ? 1 : 0
              );
            }}
            />
            <label
            className="custom-control-label"
            htmlFor="upcoming_opendays_show_block"
            >
            Show Section
            </label>
            </div>
            </div>
            </div>
            <div className="col-md-6 col-lg-9">
            <label htmlFor="upcoming_opendays_text" title="Site Name">Section Title Text</label>
            <div className="form-icon-group" title="site_Name">
            <input
            type="text"
            className={`form-control ${formik.touched.upcoming_opendays_text && formik.errors.upcoming_opendays_text && "is-invalid"
            }`}
            name="upcoming_opendays_text"
            id="upcoming_opendays_text"
            title="Section Title Text"
            placeholder="Section Title Text"
            value={formik.values?.upcoming_opendays_text}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            />
            </div>
            </div>
            </div>
            <SectionColorOverrideComponent 
            prefix="openday_" 
            formik={formik} 
            fields={["accentColor", "textColorOne", "textColorTwo", "backgroundColor"]} />
            <hr />
            </div>
            
            <div className="col-12">
            <div className="row pt-1">
            <div className="col-md-12">
            <div className="edit-icon new-card-header">
            <h4 className="card-header">Learning Methods Block</h4>
            </div>
            </div>
            
            <div className={`col-md-6 col-lg-3`}>
            <label htmlFor={"Section Settings"}>
            Section Settings
            </label>
            <div className="form-icon-group mb-4 mt-3">
            <div className="custom-control custom-checkbox text-left mr-3" title="Show Block">
            <input
            type="checkbox"
            className="custom-control-input"
            id="learning_method_show_block"
            name="learning_method_show_block"
            checked={formik.values?.learning_method_show_block == 1}
            onChange={(e) => {
              formik.setFieldValue(
                "learning_method_show_block",
                e.target.checked ? 1 : 0
              );
            }}
            />
            <label
            className="custom-control-label"
            htmlFor="learning_method_show_block"
            >
            Show Section
            </label>
            </div>
            </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
            <div className="form-group-blk mb-3" title="Section Variant">
            <label htmlFor="learning_method_block_variant">Section Variant <i className="fal fa-info-circle grade-icon"></i>
            </label>
            <Select
            className={
              "form-control custom-select-box " +
              (formik.errors.learning_method_block_variant && formik.touched.learning_method_block_variant
                ? " is-invalid"
                : "")
              }
              name="learning_method_block_variant"
              value={learnignBlockArr.filter(
                (item) => item.value == formik.values?.learning_method_block_variant
              )}
              onChange={(value) => {
                if (value) {
                  formik.setFieldValue("learning_method_block_variant", value.value);
                } else {
                  formik.setFieldValue("learning_method_block_variant", "");
                }
              }}
              onBlur={formik.handleBlur}
              options={learnignBlockArr}
              maxMenuHeight={175}
              placeholder={"Select Section Variant"}
              />
              </div>
              </div>
              
              <div className="col-md-6 col-lg-4">
              <label htmlFor="learning_method_block_text" title="Site Name">Section Title Text</label>
              <div className="form-icon-group" title="site_Name">
              <input
              type="text"
              className={`form-control ${formik.touched.learning_method_block_text && formik.errors.learning_method_block_text && "is-invalid"
              }`}
              name="learning_method_block_text"
              id="learning_method_block_text"
              title="Section Title Text"
              placeholder="Section Title Text"
              value={formik.values?.learning_method_block_text}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              />
              </div>
              </div>
              </div>
              <SectionColorOverrideComponent 
              prefix="learning_method_" 
              formik={formik} 
              fields={["accentColor", "textColorOne", "textColorTwo", "backgroundColor"]} />
              <hr />
              </div>
              
              <div className="col-12">
              <div className="row pt-1">
              <div className="col-md-12">
              <div className="edit-icon new-card-header">
              <h4 className="card-header">Testimonials Block</h4>
              </div>
              </div>
              
              <div className={`col-md-6 col-lg-3`}>
              <label htmlFor={"Section Settings"}>
              Section Settings
              </label>
              <div className="form-icon-group mb-4 mt-3">
              <div className="custom-control custom-checkbox text-left mr-3" title="Show Block">
              <input
              type="checkbox"
              className="custom-control-input"
              id="testimonials_block_show"
              name="testimonials_block_show"
              checked={formik.values?.testimonials_block_show == 1}
              onChange={(e) => {
                formik.setFieldValue(
                  "testimonials_block_show",
                  e.target.checked ? 1 : 0
                );
              }}
              />
              <label
              className="custom-control-label"
              htmlFor="testimonials_block_show"
              >
              Show Section
              </label>
              </div>
              </div>
              </div>
              
              <div className="col-md-6 col-lg-4">
              <div className="form-group-blk mb-3" title="Section Variant">
              <label htmlFor="testimonials_block_variant">Section Variant <i className="fal fa-info-circle grade-icon"></i>
              </label>
              <Select
              className={
                "form-control custom-select-box " +
                (formik.errors.testimonials_block_variant && formik.touched.testimonials_block_variant
                  ? " is-invalid"
                  : "")
                }
                name="Linked PMC Programme"
                value={testimonialsBlockArr.filter(
                  (item) => item.value == formik.values?.testimonials_block_variant
                )}
                onChange={(value) => {
                  if (value) {
                    formik.setFieldValue("testimonials_block_variant", value.value);
                  } else {
                    formik.setFieldValue("testimonials_block_variant", "");
                  }
                }}
                onBlur={formik.handleBlur}
                options={testimonialsBlockArr}
                maxMenuHeight={175}
                placeholder={"Select Section Variant"}
                />
                </div>
                </div>
                
                <div className="col-md-6 col-lg-4">
                <label htmlFor="testimonials_block_text" title="Site Name">Section Title Text</label>
                <div className="form-icon-group" title="site_Name">
                <input
                type="text"
                className={`form-control ${formik.touched.testimonials_block_text && formik.errors.testimonials_block_text && "is-invalid"
                }`}
                name="testimonials_block_text"
                id="testimonials_block_text"
                title="Section Title Text"
                placeholder="Section Title Text"
                value={formik.values?.testimonials_block_text}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                />
                </div>
                </div>
                </div>
                <SectionColorOverrideComponent 
                prefix="testimonials_" 
                formik={formik} 
                fields={["accentColor", "textColorOne", "textColorTwo", "backgroundColor"]} />
                <hr />
                </div>
                
                <div className="col-12">
                <div className="row pt-1">
                <div className="col-md-12">
                <div className="edit-icon new-card-header">
                <h4 className="card-header">News Block</h4>
                </div>
                </div>
                
                <div className={`col-md-6 col-lg-3`}>
                <label htmlFor={"Section Settings"}>
                Section Settings
                </label>
                <div className="form-icon-group mb-4 mt-3">
                <div className="custom-control custom-checkbox text-left mr-3" title="Show Block">
                <input
                type="checkbox"
                className="custom-control-input"
                id="news_block_show"
                name="news_block_show"
                checked={formik.values?.news_block_show == 1}
                onChange={(e) => {
                  formik.setFieldValue(
                    "news_block_show",
                    e.target.checked ? 1 : 0
                  );
                }}
                />
                <label
                className="custom-control-label"
                htmlFor="news_block_show"
                >
                Show Section
                </label>
                </div>
                </div>
                </div>
                <div className="col-md-6 col-lg-9">
                <label htmlFor="news_block_text" title="Site Name">Section Title Text</label>
                <div className="form-icon-group" title="site_Name">
                <input
                type="text"
                className={`form-control ${formik.touched.news_block_text && formik.errors.news_block_text && "is-invalid"
                }`}
                name="news_block_text"
                id="news_block_text"
                title="Section Title Text"
                placeholder="Section Title Text"
                value={formik.values?.news_block_text}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                />
                </div>
                </div>
                </div>
                <SectionColorOverrideComponent 
                prefix="news_" 
                formik={formik} 
                fields={["accentColor", "textColorOne", "textColorTwo", "backgroundColor"]} />
                </div>
                <hr/>
                </>): ""}
                
                <div className="col-md-12">
                <div className="edit-icon new-card-header mb-4 mt-1" title="SEO Settings">
                <h4 className="card-header">
                <i
                className="fal fa-cog"
                style={{ color: "var(--topbar-color)" }}
                ></i> SEO Settings
                </h4>
                </div>
                </div>
                <div className="col-md-6 col-lg-6">
                <div className="form-group-blk mb-3" title="conversion">
                <label htmlFor="code">Conversion Code</label>
                <input
                type="text"
                className={
                  "form-control" +
                  (formik.errors.conversion_code && formik.touched.conversion_code
                    ? " is-invalid"
                    : "")
                  }
                  placeholder="Enter Conversion Code"
                  name="conversion_code"
                  id="conversion"
                  maxLength={20}
                  value={formik.values?.conversion_code}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  />
                  </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                  <div className="form-group-blk mb-3" title="Meta Title">
                  <label>Meta Title</label>
                  <input
                  type="text"
                  className={
                    "form-control" +
                    (formik.errors.metaTitle && formik.touched.metaTitle
                      ? " is-invalid"
                      : "")
                    }
                    placeholder="Enter Meta Title"
                    name="metaTitle"
                    value={formik.values?.metaTitle}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    />
                    </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                    <div className="form-group-blk mb-3" title="Meta Description">
                    <label>Meta Description</label>
                    <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.errors.metaDescription && formik.touched.metaDescription
                        ? " is-invalid"
                        : "")
                      }
                      placeholder="Enter Meta Description"
                      name="metaDescription"
                      value={formik.values?.metaDescription}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      />
                      </div>
                      </div>
                      <div className="col-md-6 col-lg-6">
                      <div className="form-group-blk mb-3" title="Meta Keywords">
                      <label>Meta Keywords</label>
                      <input
                      type="text"
                      className={
                        "form-control" +
                        (formik.errors.metaKeywords && formik.touched.metaKeywords
                          ? " is-invalid"
                          : "")
                        }
                        placeholder="Enter Meta Keywords"
                        name="metaKeywords"
                        value={formik.values?.metaKeywords}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        />
                        </div>
                        </div>
                        <div className="col-md-12">
                        <div className="edit-icon new-card-header mb-4 mt-1" title="Style Settings">
                        <h4 className="card-header">
                        <i
                        className="fal fa-cog"
                        style={{ color: "var(--topbar-color)" }}
                        ></i> Style Settings
                        </h4>
                        </div>
                        </div>
                        
                        <div className="col-md-6 col-lg-3 d-flex align-items-center" title="Add Custom CSS">
                        <label className="mb-0">
                        Add Custom CSS <i className="fal fa-info-circle"></i>
                        </label>
                        <div className="toggle-switch ml-2">
                        <label className="switch">
                        <input
                        type="checkbox"
                        checked={formik.values?.addCustomCss === 1}
                        name="addCustomCss"
                        onChange={(e) => {
                          formik.setFieldValue("addCustomCss", e.target.checked ? 1 : 0);
                        }}
                        />
                        <span className="slider slider-round"></span>
                        </label>
                        </div>
                        </div>
                        
                        {formik.values?.addCustomCss == 1 && <div className="col-md-12">
                          <div className=" mb-3 mt-3" title="Customs CSS">
                          <label>Customs CSS*</label>
                          <div className="html-editor-input">
                          <CSSEditor 
                         value={formik.values.customCss}
                         onChange={(value) => formik.setFieldValue('customCss', value)}
                         onBlur={formik.handleBlur}
                         className={formik.touched.customCss && formik.errors.customCss ? "is-invalid" : ""}
                         placeholder="Enter CSS code..."
                         />          
                          <div className="headerf">
                          <span className="title fw-bolds"> CSS</span>
                          </div>
                          </div>
                          </div>
                          </div>
                        }
                        </div>
                        </div>
                        <div className="form-group form-group-save-cancel mt-4">
                        <PermissionsGate scopes={["partneredit"]} errorProps={{ disabled: true }}>
                        <button
                        className="btn btn-save btn-success"
                        type="submit"
                        title="Save"
                        disabled={loading}
                        onClick={formik.handleSubmit}
                        >
                        
                        {loading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
                        
                        Save
                        </button>
                        </PermissionsGate>
                        <button
                        className="btn btn-close btn-danger"
                        type="button"
                        title="Cancel"
                        onClick={() =>formik.resetForm()}
                        >
                        <i className="fal fa-times"></i>Cancel
                        </button>
                        </div> 
                        {Object.keys(formik.errors).length > 0 && Object.keys(formik.errors).map((key) => {
                          if (formik.touched[key]) {
                            return (
                              <div className="invalid-feedback d-block" key={key}>
                              {formik.errors[key]}
                              </div>
                            );
                          }
                          return null;
                        })}
                        </div>
                        </form>
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        </>
                      );
                    };
                    
                    export default PartnerDetails;
                    